/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  constructor (emphasis)
  {
    this.emphasis = emphasis;
  }


  matches (zone)
  {
    return !this.emphasis.matches(zone);
  }


  equals (other)
  {
    return other !== null && other.constructor === this.constructor && this.emphasis.equals(other.emphasis);
  }


};
